module.exports = __webpack_public_path__ + "img/fish.c83571b0.jpeg";